import { configureStore } from '@reduxjs/toolkit';
import viewReducer from '../../manageViews/store/slices/viewSlice';
import dropdownDataReducer from '../../manageViews/store/slices/dropdownDataSlice';
import messageBarReducer from '../../manageViews/store/slices/messageBarSlice';
import hubOverviewMessageBarReducer from '../../manageViews/store/slices/hubOverviewMessageBarSlice';
import userReducer from '../../manageViews/store/slices/userSlice';
import previewDataReducer from '../../manageViews/store/slices/previewDataSlice';
import userRatingReducer from '../../manageViews/store/slices/userRatingSlice';
import AllDataReducer from '../../manageViews/store/slices/getAllDataSlice';
import { dashboardSummarySlice } from 'src/Common/dashboardSummary/store/slices/dashboardActionsSlice';
import { copilotSlice } from 'src/Common/dashboardSummary/store/slices/copilotSlice';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { setupListeners } from '@reduxjs/toolkit/query';
import { rtkApi } from '../api/rtkApi';
import { copilotApi } from '../api/copilotApi';
import { uamApi } from '../api/dashboardApi';
import { commonServicesBaseApi } from '../api/commonServicesBaseApi';
import { formEngineApi } from '../api/formEngineApi';
import { manageActionSlice } from '../../../manageAction/store/slices/ManageActionSlices';
import manageActionReducer from '../../../manageAction/store/slices/ManageActionSlices';
import manageActionValidationReducer from '../../../manageAction/store/slices/ManageActionValidationSlices';
import { getActionDataApi } from 'src/manageAction/store/services/getActionApi';
import { cosellValidationSlice } from 'src/manageAction/store/slices/CosellValidationSlice';
import { dropdownDataApi } from 'src/Common/manageViews/store/service/dropdownDataApi';
import { createActionSlice } from '../../../features/createAction/store/slices/CreateActionSlices';
import createActionSliceReducer from '../../../features/createAction/store/slices/CreateActionSlices';
import { manageActionCosmosSlice } from 'src/manageAction/store/slices/ManageActionCosmosDataSlice';
import manageActionCosmosSliceReducer from 'src/manageAction/store/slices/ManageActionCosmosDataSlice';
import { getRaidEntityApi } from 'src/manageAction/store/services/getRaidEntityApi';
import { manageTenantSlice } from 'src/features/HubOverview/store/slice/multiTenantDashboardSlice';
import { getViewsDataApi } from 'src/features/HubOverview/store/service/multitenantDashboardApi';
import { artemisViewsApi } from 'src/features/HubOverview/store/service/artemisViewsApi';
import { reducer as filterReducer } from '../../../App/Reducers/FilterReducer';
import { viewApi } from 'src/Common/manageViews/store/service/viewApiSlice';
import { GPSActionApi } from 'src/manageAction/store/services/GPSActionApiSlice';
import { GPSActionStateSlice } from 'src/manageAction/store/slices/GPSActionSlice';

import { PMYTValidationSlice } from 'src/manageAction/store/slices/PMYTValidationSlice';
import tenantReducer from 'src/tenantConfig/slice/tenantSlice';
import taxonomyReducer from 'src/tenantConfig/slice/taxonomySlice';
import { commonApi } from 'src/manageAction/store/services/commonApi';
import { OtherWebApi } from 'src/features/HubOverview/store/service/OtherWebApi';
import { OtherWebAPIStateSlice } from 'src/features/HubOverview/store/slice/OtherWebApiSlice';
import toastReducer from '../../../features/createAction/store/slices/ToastSlice';
import messageReducer from '../../../features/createAction/store/slices/MessageSlice';
import copilotV2Reducer from 'src/copilot-v2/store/copilotSlice';
import { copilotApi as copilotV2Api } from 'src/copilot-v2/Store/copilotApi';
import { promptGalleryReducer } from 'src/copilot-v2/store/promptGallerySlice';
import { promptGalleryApi } from 'src/copilot-v2/store/promptGalleryApi';
import copilotConfigReducer from 'src/copilot-v2/store/copilotConfigSlice';
import { copilotConfigApi } from 'src/copilot-v2/store/copilotConfigApi';
import featureFlagsReducer from 'src/copilot-v2/store/featureFlagsSlice';
import copilotMessageBarReducer from 'src/copilot-v2/store/messageBarSlice';
import copilotTenantSelectionReducer from 'src/copilot-v2/store/tenantSelectionSlice';

//Validation Automation
import { validationAutomationApi } from 'src/manageAction/store/services/ValidationAutomationApi';

export const store = configureStore({
  reducer: {
    [dashboardSummarySlice.reducerPath]: dashboardSummarySlice.reducer,
    [copilotSlice.reducerPath]: copilotSlice.reducer,
    [rtkApi.reducerPath]: rtkApi.reducer,
    [commonServicesBaseApi.reducerPath]: commonServicesBaseApi.reducer,
    [formEngineApi.reducerPath]: formEngineApi.reducer,
    [copilotApi.reducerPath]: copilotApi.reducer,
    [uamApi.reducerPath]: uamApi.reducer,
    [dropdownDataApi.reducerPath]: dropdownDataApi.reducer,
    [manageActionSlice.reducerPath]: manageActionSlice.reducer,
    [getActionDataApi.reducerPath]: getActionDataApi.reducer,
    [cosellValidationSlice.reducerPath]: cosellValidationSlice.reducer,
    [createActionSlice.reducerPath]: createActionSlice.reducer,
    [getRaidEntityApi.reducerPath]: getRaidEntityApi.reducer,
    [manageActionCosmosSlice.reducerPath]: manageActionCosmosSlice.reducer,
    [manageTenantSlice.reducerPath]: manageTenantSlice.reducer,
    [getViewsDataApi.reducerPath]: getViewsDataApi.reducer,
    [artemisViewsApi.reducerPath]: artemisViewsApi.reducer,
    [PMYTValidationSlice.reducerPath]: PMYTValidationSlice.reducer,
    [viewApi.reducerPath]: viewApi.reducer,
    [GPSActionApi.reducerPath]: GPSActionApi.reducer,
    [GPSActionStateSlice.reducerPath]: GPSActionStateSlice.reducer,
    [commonApi.reducerPath]: commonApi.reducer,
    [OtherWebAPIStateSlice.reducerPath]: OtherWebAPIStateSlice.reducer,
    [OtherWebApi.reducerPath]: OtherWebApi.reducer,
    [validationAutomationApi.reducerPath]: validationAutomationApi.reducer,
    viewSlice: viewReducer,
    dropdownDataSlice: dropdownDataReducer,
    messageBarSlice: messageBarReducer,
    hubOverviewMessageBarSlice: hubOverviewMessageBarReducer,
    userSlice: userReducer,
    previewDataView: previewDataReducer,
    userRatingSlice: userRatingReducer,
    getAllData: AllDataReducer,
    manageActionSlice: manageActionReducer,
    manageActionValidationSlice: manageActionValidationReducer,
    createActionSlice: createActionSliceReducer,
    manageActionCosmosSlice: manageActionCosmosSliceReducer,
    filter: filterReducer,
    tenant: tenantReducer,
    taxonomy: taxonomyReducer,
    toasts: toastReducer,
    messages: messageReducer,
    copilotV2: copilotV2Reducer,
    [copilotV2Api.reducerPath]: copilotV2Api.reducer,
    promptGallery: promptGalleryReducer,
    [promptGalleryApi.reducerPath]: promptGalleryApi.reducer,
    copilotConfig: copilotConfigReducer,
    [copilotConfigApi.reducerPath]: copilotConfigApi.reducer,
    copilotFeatureFlags: featureFlagsReducer,
    copilotMessageBar: copilotMessageBarReducer,
    copilotTenantSelection: copilotTenantSelectionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat([
      rtkApi.middleware,
      commonServicesBaseApi.middleware,
      formEngineApi.middleware,
      copilotApi.middleware,
      uamApi.middleware,
      getActionDataApi.middleware,
      GPSActionApi.middleware,
      viewApi.middleware,
      dropdownDataApi.middleware,
      getRaidEntityApi.middleware,
      getViewsDataApi.middleware,
      artemisViewsApi.middleware,
      commonApi.middleware,
      OtherWebApi.middleware,
      validationAutomationApi.middleware,
      copilotV2Api.middleware,
      promptGalleryApi.middleware,
      copilotConfigApi.middleware,
    ]),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
// Generated by GitHub Copilot | Updated on: 2026-04-13 | 2 lines modified | Added taxonomyReducer import and registered in store
